import * as z from 'zod'
import emailSchema from './emailSchema'

const notEmptyString = () => z.string().nonempty()

export const schema = emailSchema.extend({
  title: notEmptyString(),
  company: notEmptyString(),
  department: notEmptyString(),
  firstName: notEmptyString(),
  lastName: notEmptyString(),
  phone: notEmptyString(),
  termCheck: z.boolean().refine((v) => v === true)
})

export default schema
